import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, withStyles } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import MuiFormHelperText from '@material-ui/core/FormHelperText';
import * as React from 'react';
import palette from '../palette';
const FormHelperText = withStyles(theme => ({
  root: {
    color: palette.GREEN_DAY,
    fontSize: 14,
    paddingTop: theme.spacing(1),
    '&$error': {
      color: palette.HOTEL_CALIFORNIA
    },
    '&$disabled': {
      color: alpha(theme.palette.common.black, 0.38)
    }
  },
  error: {},
  disabled: {}
}))(MuiFormHelperText);

const InputHelperText = ({
  message,
  collapseProps,
  ...props
}) => _jsx(Collapse, {
  in: !!message,
  ...collapseProps,
  children: _jsx(FormHelperText, { ...props,
    children: message || ' '
  })
});

export default InputHelperText;